import React from 'react'

export default function Earn() {
  return (
    <div style={{
      color: "#54616c",
      margin : "1rem",
      padding : "10px",
    }}>
    <h3>Invite Friends and Earn Credits</h3>
    <p style={{textAlign: "left"}}>You'll receive 1 credit when the person you invite signs up for a remove.bg account, and they'll also get 1 extra credit to get started (on top of the 1 credit for signing up). Win-Win!

</p>
    </div>
  )
}
